export const RegisterPushTokenMutation = (devicePushToken) => {
  return `
    mutation RegisterPushToken($devicePushToken: String) {
      registerPushToken(devicePushToken: $devicePushToken) {
        success
        errors
        user {
          id
          username
        }
      }
    }
  `;
};
